/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class ScreenTaskControllerTypes {
    static AUDIO_TRACK_OVERLAY = 'AUDIO_TRACK_OVERLAY';

    static CHANNEL_OPTIONS_OVERLAY = 'CHANNEL_OPTIONS_OVERLAY';

    static DEFAULT_ANTIBURN_OSD_TASKS = 'DEFAULT_ANTIBURN_OSD_TASKS';

    static DEFAULT_ERROR_TASKS = 'DEFAULT_ERROR_TASKS';

    static DEFAULT_GUIDE_TASKS = 'DEFAULT_GUIDE_TASKS';

    static DEFAULT_SETTING_TASKS = 'DEFAULT_SETTING_TASKS';

    static DEFAULT_SIGN_IN_TASKS = 'DEFAULT_SIGN_IN_TASKS';

    static DEFAULT_SPLASH_SCREEN_TASKS = 'DEFAULT_SPLASH_SCREEN_TASKS';

    static DEFAULT_VIDEO_PLAYER_TASKS = 'DEFAULT_VIDEO_PLAYER_TASKS';

    static ENTER_CHANNEL_NUMBER = 'ENTER_CHANNEL_NUMBER';

    static EXIT_CONFIRMATION_OVERLAY = 'EXIT_CONFIRMATION_OVERLAY';

    static FULL_INFO = 'FULL_INFO';

    static GUIDE_INTERACTIVE_LAYER_TASKS = 'GUIDE_INTERACTIVE_LAYER_TASKS';

    static GUIDE_SPINNER_TASKS = 'GUIDE_SPINNER_TASKS';

    static LANGUAGE_NOT_SUPPORTED_OVERLAY = 'LANGUAGE_NOT_SUPPORTED_OVERLAY';

    static LIVE_TV_INTERACTIVE_LAYER_TASKS = 'LIVE_TV_INTERACTIVE_LAYER_TASKS';

    static LP_CODE_EXPIRED_SIGNIN_TASK = 'LP_CODE_EXPIRED_SIGNIN_TASK';

    static NO_NETWORK_OVERLAY = 'NO_NETWORK_OVERLAY';

    static NO_TASK: 'NO_TASK';

    static PLAYER_ERROR_OVERLAY = 'PLAYER_ERROR_OVERLAY';

    static PREPARING_VOD_RESUME_START_OVER_OVERLAY_TASKS =
        'PREPARING_VOD_RESUME_START_OVER_OVERLAY_TASKS';

    static RECORD_OVERLAY_TASKS = 'RECORD_OVERLAY_TASKS';

    static SETTINGS_ACCOUNT_TASKS = 'SETTINGS_ACCOUNT_TASKS';

    static SETTINGS_INTERACTIVE_LAYER_TASKS = 'SETTINGS_INTERACTIVE_LAYER_TASKS';

    static SETTINGS_MENU_LANGUAGE_TASKS = 'SETTINGS_MENU_LANGUAGE_TASKS';

    static SETTINGS_RESET_APP_OVERLAY_TASKS = 'SETTINGS_RESET_APP_OVERLAY_TASKS';

    static SETTINGS_SIGN_OUT_OVERLAY_TASKS = 'SETTINGS_SIGN_OUT_OVERLAY_TASKS';

    static SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS = 'SETTINGS_SIGN_OUT_ERROR_OVERLAY_TASKS';

    static SETTINGS_USER_PREFERENCE_TASKS = 'SETTINGS_USER_PREFERENCE_TASKS';

    static SETTINGS_VIDEO_WINDOW_TASKS = 'SETTINGS_VIDEO_WINDOW_TASKS';

    static SIGN_IN_ERROR_OVERLAY_TASKS = 'SIGN_IN_ERROR_OVERLAY_TASKS';

    static SOCU_ERROR_OVERLAY_TASKS = 'SOCU_ERROR_OVERLAY_TASKS';

    static SOS_ERROR_TASKS = 'SOS_ERROR_TASKS';

    static STANDARD_INFO = 'STANDARD_INFO';

    static STILL_THERE_OSD_TASKS = 'STILL_THERE_OSD_TASKS';

    static SUBTITLE_AND_CC_LANGUAGE_OVERLAY = 'SUBTITLE_AND_CC_LANGUAGE_OVERLAY';

    static TEMPORARY_GUIDE_ISSUE_OVERLAY = 'TEMPORARY_GUIDE_ISSUE_OVERLAY';

    static TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY =
        'TEMPORARY_SERVICE_CONNECTION_ISSUE_OVERLAY';

    static TRICKPLAY_MENU = 'TRICKPLAY_MENU';

    static TURBO_SCROLL = 'TURBO_SCROLL';

    static VOD_RESUME_START_OVER_OVERLAY_TASKS = 'VOD_RESUME_START_OVER_OVERLAY_TASKS';
}
